import { render, staticRenderFns } from "./ModalRelatoriosFechamento.vue?vue&type=template&id=79e4dc9a&"
import script from "./ModalRelatoriosFechamento.vue?vue&type=script&lang=js&"
export * from "./ModalRelatoriosFechamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports